module.exports = __webpack_public_path__ + "assets/img/init_pos_wallpaper1.852faa19.png";